export default __webpack_public_path__ + "static/media/img-0791-portugal-premium-face.b43d1203.png";